var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevokecertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.907,
    height: 23,
    viewBox: "0 0 23.907 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8816",
    "data-name": "Group 8816",
    transform: "translate(-636.233 -888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8815",
    "data-name": "Group 8815",
    transform: "translate(517.447 137.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M10.148,5.536H3.692V4.609h6.457ZM5.71,7.39H3.692v.927L5.71,8.158Zm12.455-.87c-.579-.4-.5-.3-.721-.959a.683.683,0,0,0-.65-.46h0c-.713,0-.59.041-1.167-.365a.7.7,0,0,0-.807,0c-.58.41-.454.369-1.167.365h0a.683.683,0,0,0-.65.46c-.22.658-.144.556-.72.959a.652.652,0,0,0-.284.536l.034.206c.223.656.223.53,0,1.185l-.034.206a.651.651,0,0,0,.285.536c.576.4.5.3.72.958a.681.681,0,0,0,.65.459h0c.713,0,.59-.042,1.167.365a.7.7,0,0,0,.806,0c.576-.407.452-.368,1.167-.365h0a.681.681,0,0,0,.65-.459c.22-.656.142-.555.721-.958a.654.654,0,0,0,.284-.537l-.034-.206c-.223-.658-.221-.531,0-1.185l.034-.206A.649.649,0,0,0,18.166,6.52ZM15.221,9.244a1.391,1.391,0,1,1,1.384-1.391A1.388,1.388,0,0,1,15.221,9.244Zm1.145,2.788.019-.007h1.142v6.489l-2.287-1.39-2.325,1.39V12.025h1.135a1.78,1.78,0,0,0,1.171.464A1.7,1.7,0,0,0,16.366,12.033ZM0,1.7V6.032H1.847V2.6L2,2.25l.241-.2.479-.219,16.431-.022h.529l.469.186.072.193.1.271V3.483l-.026,10.4h-.922v1.854H20.8l.35-.118.278-.166.153-.127.146-.133.1-.122.1-.193.1-.244.116-.51V1.616l-.186-.54L21.6.664l-.36-.3L20.754.144,19.786,0H1.847L1.227.18.668.553l-.416.52L0,1.7Z",
    transform: "translate(120.554 752.87)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close_black_24dp",
    transform: "translate(120.553 759.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_4763",
    "data-name": "Path 4763",
    transform: "translate(-5 -5)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.606,5.867,12.739,5,9.3,8.436,5.867,5l-.553.553L5,5.867,6.971,7.838,8.436,9.3,5,12.739l.867.867L9.3,10.17l3.436,3.436.867-.867L10.17,9.3Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.866744995117188 4.999995231628418 L 4.999995231628418 5.866744995117188 L 8.43625545501709 9.303005218505859 L 4.999995231628418 12.73926544189453 L 5.866744995117188 13.6060152053833 L 9.303005218505859 10.16975498199463 L 12.73926544189453 13.6060152053833 L 13.6060152053833 12.73926544189453 L 10.16975498199463 9.303005218505859 L 13.6060152053833 5.866744995117188 L 12.73926544189453 4.999995231628418 L 9.303005218505859 8.43625545501709 L 5.866744995117188 4.999995231628418 M 5.866735458374023 3.23222541809082 L 9.303005218505859 6.668495178222656 L 12.73926544189453 3.23222541809082 L 15.3737850189209 5.866744995117188 L 11.93751525878906 9.303005218505859 L 15.3737850189209 12.73926544189453 L 12.73926544189453 15.3737850189209 L 9.303005218505859 11.93751525878906 L 5.866744995117188 15.3737850189209 L 3.23222541809082 12.73926544189453 L 6.668495178222656 9.303005218505859 L 3.23221492767334 5.866735458374023 L 5.866735458374023 3.23222541809082 Z",
    stroke: "none",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38943",
    "data-name": "Rectangle 38943",
    width: 2.805,
    height: 1.509,
    transform: "translate(9.315 7.297)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Assignment",
    transform: "translate(649 910)",
    fill: "currentColor",
    fontSize: 22,
    fontFamily: "MaterialIconsOutlined-Regular, Material Icons Outlined",
    opacity: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11,
    y: 0
  }, "\uE85D")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokecertificate);
export default __webpack_public_path__ + "static/media/Revokecertificate.484d9ea3db2c06f25cee7128c54b5636.svg";
export { ForwardRef as ReactComponent };